import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowUpRight, Inbox } from "lucide-react";

import setAuthToken from "../../../utils/setAuthToken";
import { formatDateWidget } from "../../../utils/dateUtils";

import { Spinner, StatusIndicator } from "../../../design-system";

class LatestNewsletters extends Component {
  constructor(props) {
    super(props);
    this.state = { subscribers: [], loading: true };
  }

  componentDidMount() {
    this.loadSubscribers();
  }

  loadSubscribers = async () => {
    try {
      const token = localStorage.getItem("jwtToken");
      if (token) setAuthToken(token);
      const response = await axios.get("/api/newsletters/subscribers?limit=5");
      if (response.data.success) {
        this.setState({ subscribers: response.data.subscribers || [], loading: false });
      }
    } catch (error) {
      console.error("Error loading subscribers:", error);
      this.setState({ loading: false });
    }
  };

  render() {
    const { subscribers, loading } = this.state;

    return (
      <div className="flex flex-col h-full">
        <header className="flex items-center justify-between px-4 py-3 border-b border-border">
          <h3 className="text-sm font-bold tracking-tight">Derniers abonnés</h3>
          <Link to="/dashboard/newsletter" className="text-xs font-medium text-mute hover:text-text inline-flex items-center gap-1">
            Voir tout <ArrowUpRight className="w-3 h-3" strokeWidth={1.8} />
          </Link>
        </header>
        <div className="flex-1">
          {loading ? (
            <div className="flex items-center justify-center py-8 text-mute"><Spinner size="sm" /></div>
          ) : subscribers.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-8 text-center text-mute text-sm">
              <Inbox className="w-5 h-5 mb-2 text-mute-2" strokeWidth={1.6} />
              Aucun abonné
            </div>
          ) : (
            <ul className="divide-y divide-border">
              {subscribers.map((subscriber) => (
                <li key={subscriber.id} className="px-4 py-3">
                  <div className="flex items-start justify-between gap-2 mb-1">
                    <span className="text-sm font-semibold text-text leading-tight">
                      {subscriber.name || subscriber.email}
                    </span>
                    {subscriber.active
                      ? <StatusIndicator tone="ink" size="sm">Actif</StatusIndicator>
                      : <StatusIndicator tone="muted" size="sm">Inactif</StatusIndicator>}
                  </div>
                  <div className="flex items-center gap-2 text-[11.5px] text-mute">
                    <span className="truncate">{subscriber.email}</span>
                    <span className="text-mute-2">·</span>
                    <span className="font-mono">{formatDateWidget(subscriber.subscribedAt)}</span>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    );
  }
}

export default LatestNewsletters;
